import httpClient from '@/lib/httpClient'
import { handleFormError } from '@/utils/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useConfirmTwoFactor({
  setError = null,
  clientServerFieldMapping = null,
} = {}) {
  const queryClient = useQueryClient()

  const action = async ({ code }: { code: string | number }) => {
    const response = await httpClient.post(
      'auth/user/confirmed-two-factor-authentication',
      { code },
    )
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (error, variables) =>
      handleFormError({
        error,
        variables,
        setError,
        clientServerFieldMapping,
      }),
    onSuccess: (res, variables) => {
      toast.success(' Two factor authentication confirmed')
      // queryClient.invalidateQueries({ queryKey: ['current-user'] })
    },
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
